import React from 'react';
import styles from '../asset/scoreStatisticBoard.module.scss';

const WarningIcon = () => (
    <svg className={styles.warningIcon} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9" cy="9" r="8" stroke="#777E90" strokeWidth="1.5" />
        <path d="M9 5V10" stroke="#777E90" strokeWidth="1.5" strokeLinecap="round" />
        <circle cx="9" cy="13" r="0.75" fill="#777E90" />
    </svg>
);

export default WarningIcon;
